<template>
  <div>
    <PageAllow controller="Distributions" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("Distribution.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="distribution.status | distributionStatusColor"
                :text-color="distribution.status | distributionStatusTextColor"
                >{{ distribution.status | distributionStatusText }}
              </v-chip>
              <v-spacer />
              <DistributionActions
                :distribution="distribution"
                :showDistribute="
                  distribution && distribution.actions
                    ? distribution.actions.distribute
                    : false
                "
                :showLogistic="
                  distribution && distribution.actions
                    ? distribution.actions.logistic
                    : false
                "
                @distribute="toDistribute($event)"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.distribution_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ distribution.distributions_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      :href="'/#/orders/' + distribution.order_id"
                      style="text-decoration: none"
                    >
                      {{ distribution.order_code }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ distribution.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 配送点名称 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.delivery_point"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.delivery_point")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="distribution.delivery_point_province_id">
                    {{
                      $t("Distribution.Fields.delivery_point_name", [
                        distribution.delivery_point_code,
                        distribution.delivery_point_name,
                      ])
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 配送点负责人 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.delivery_point"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.delivery_point_manager")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.delivery_point_manager }}
                  </span>
                </v-card>
              </v-col>
              <!-- 配送点联系方式 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.delivery_point"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.delivery_point_tel")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.delivery_point_tel }}
                  </span>
                </v-card>
              </v-col>
              <!-- 配送点地址 -->
              <v-col
                cols="12"
                md="12"
                v-if="settings && settings.delivery_point"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.delivery_point_address")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.delivery_point_full_address }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-inline d-md-none">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.distribute_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.distribution_time | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Distribution.DetailFields.shop_name", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    distribution && distribution.shop
                      ? distribution.shop.shop_name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-none d-md-inline">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.Fields.distribute_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.distribution_time | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.DetailFields.consignee")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      receiverInfo
                        ? receiverInfo.user_name
                        : distribution.shop_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Distribution.DetailFields.receiver_tel")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>{{
                    receiverInfo
                      ? receiverInfo.tel
                      : distribution &&
                        distribution.shop &&
                        distribution.shop.shop_user
                      ? distribution.shop.shop_user.tel
                      : ""
                  }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Distribution.DetailFields.shop_address", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="receiverInfo">{{ receiverInfo.address }}</span>
                  <AddressText
                    v-else
                    :masterItem="distribution ? distribution.shop : null"
                    :detailAddress="
                      distribution && distribution.shop
                        ? distribution.shop.address
                        : ''
                    "
                  />
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text"
                    >{{ $t("Distribution.DetailFields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ distribution.memo }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Distribution.actions.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="distribution_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="distributionDetails"
        :search="filter"
        multi-sort
        disable-pagination
        hide-default-footer
        :no-data-text="$t('Order.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("Distribution.ObjectName")]) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  distributionDetails
                    ? [
                        1,
                        distributionDetails.length,
                        distributionDetails.length,
                      ]
                    : [0, 0, 0]
                )
              }}
            </span>
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.order_num="{ item }">
          {{ item.order_num | formatTwoDot }}
        </template>
        <template v-slot:item.material_name="{ item }">
          {{ item.material_name }}
          <br />
          <span v-if="item.standard_name" class="caption secondary--text">
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
            <span
              v-if="item.standard_name && item.standard_name.length > 12"
              :title="item.standard_name"
              style="cursor: pointer"
            >
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </span>
        </template>
        <template v-slot:item.distribution_num="{ item }">
          {{ item.distribution_num | formatTwoDot }}
        </template>
        <template v-slot:item.unit="{ item }">
          {{ item.unit }}
          <span
            v-if="item.material && item.standard_detail.rate > 1"
            class="caption secondary--text"
          >
            (1{{ item.unit }}={{ item.standard_detail.rate
            }}{{ item.default_unit }})
          </span>
          <span
            v-if="
              item.barcode ||
              (item.standard_detail && item.standard_detail.barcode)
            "
            class="caption secondary--text"
          >
            <br />
            {{
              item.barcode
                ? item.barcode
                : item.standard_detail
                ? item.standard_detail.barcode
                : ""
            }}
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money") }}{{ item.price | formatMoney }}
        </template>
        <template v-slot:item.subtotal_price="{ item }">
          {{ $t("Global.money") }}{{ item.subtotal_price | formatMoney }}
        </template>
      </v-data-table>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddressText from "@/components/plugins/AddressText";
import Distributions from "@/api/distributions";
import DistributionActions from "./plugins/Actions";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    AddressText,
    DistributionActions,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          href: "/orders",
        },
        {
          text: i18n.t("Nav.distributions"),
          disabled: false,
          href: "/distributions",
        },
        {
          text: i18n.t("Nav.distributionDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.distribution && this.distribution.distributions_code
              ? this.distribution.distributions_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Distribution.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Distribution.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Distribution.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("Distribution.DetailFields.apply_num"),
          align: "end",
          value: "order_num",
        },
        {
          text: i18n.t("Distribution.DetailFields.distribute_num"),
          align: "end",
          value: "distribution_num",
        },
        {
          text: i18n.t("Distribution.DetailFields.unit"),
          align: "end",
          value: "unit",
        },
        {
          text: i18n.t("Distribution.DetailFields.stock_distribution_num"),
          align: "end",
          value: "stock_distribution_num",
        },
        {
          text: i18n.t("Distribution.DetailFields.price"),
          align: "end",
          value: "price",
        },
        {
          text: i18n.t("Distribution.DetailFields.subtotal_price"),
          align: "end",
          value: "subtotal_price",
        },
      ];

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Distribution.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Distribution.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Distribution.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  mounted() {
    this.getDistributionDetailFromAPI();
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    distribution: {},
    receiverInfo: {},
    distributionDetails: [],
    distribution_activities: [],
  }),

  methods: {
    getDistributionDetailFromAPI() {
      Distributions.fetchOne(this.$route.params.id, {
        order_activity: 1,
        merge_detail: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distribution = response.data.distribution;
            this.receiverInfo = response.data.order_address;
            this.distributionDetails =
              response.data.distribution.distribution_details;
            this.distributionDetails.forEach((detail) => {
              detail.distribution_num = parseFloat(
                detail.distribution_num
              ).toFixed(2);
              detail.price = parseFloat(detail.price).toFixed(2);
              detail.subtotal_price = this.$numberFormatter.formatMoneyFloor(
                detail.price * detail.distribution_num
              );
            });
            this.distribution_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },

    toDistribute(distribution) {
      Distributions.distribute(distribution.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace("/distributions");
          }
        }.bind(this)
      );
    },
  },
};
</script>